var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lg:w-1/6 md:w-1/4 sm:w-1/3 bg-white rounded"},[_c('v-select',{attrs:{"options":_vm.options},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }